import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import store from './store'
import { observer } from 'mobx-react'
import { getObjValue } from '@hlj/hlj-utils'
import { JUKE_PATH_A } from '@constant'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }

  render() {
    let header = (
      <p key={0}>
        <a style={{ color: '#333' }} href={JUKE_PATH_A}>
          聚客宝
        </a>{' '}
        >
        <a style={{ color: '#333' }} href={`${JUKE_PATH_A}/apply`}>
          申请活动
        </a>{' '}
        > 活动范例
      </p>
    )

    const { list, content } = store
    return (
      <HeaderView title={header}>
        <div className={styles.box}>
          <ul className={styles.left}>
            {list.length > 0 ? (
              list.map(({ activity, id }) => (
                <li key={id} onClick={store.getDetails(id)}>
                  <span>{activity}</span>
                </li>
              ))
            ) : (
              <p>没有相关记录</p>
            )}
          </ul>

          <div className={styles.right}>
            {content && content.title ? (
              <div>
                <div className={styles.title}>{content.title}</div>
                <div className={styles.inner}>
                  <div
                    dangerouslySetInnerHTML={{ __html: content.content_html }}
                  />
                </div>
              </div>
            ) : (
              <div>
                <div className={styles.title}>
                  {getObjValue(list[0], 'activity')}
                </div>
                <div className={styles.inner}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: getObjValue(list[0], 'content_html')
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </HeaderView>
    )
  }
}
